import React, {useState} from 'react';
import localeHelpers from "../../helpers/LocaleHelper";

import {useObservable} from "./observable/observableHook";
import {localeService} from "./observable/services";
import Button from "reactstrap/es/Button";

const LanguagePanel = (props) => {
    const locale = useObservable(localeService.locale);
    const [loc, setLoc] = useState(locale);

    function save(event, l) {
        event.preventDefault();
        localeHelpers.saveLocaleLocally(l);
        localeService.setLocale(l);
        setLoc(l);

        if (props.onResult !== undefined) {
            props.onResult(l)
        }
    }

    return (
        <div className="mt-0">
            <Button color={locale === "en" ? "yellowopen" : "secondary"}
                    type="button"
                    size="sm"
                    onClick={e => save(e, "en")}
            >
                eng
            </Button>

            <Button color={locale === "es" ? "yellowopen" : "secondary"}
                    type="button"
                    size="sm"
                    onClick={e => save(e, "es")}
            >
                esp
            </Button>

            <Button color={locale === "ru" ? "yellowopen" : "secondary"}
                    type="button"
                    // className="d-none"
                    size="sm"
                    onClick={e => save(e, "ru")}
            >
                рус
            </Button>
        </div>
    )
};

export default LanguagePanel;